const setCurrentPage = (state, action) => action.currentPage || state;
export default setCurrentPage;
